import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UtilService {
  toNumber(val: any = ''): any {
    return val.toString().replace(/[^0-9.]/g, '').trim();
  }

  isWithinDraftOnlineWill(today: Date = new Date()): boolean {
    const currentDate: string = today.toLocaleDateString('en-US');
    const FromDate = '10/26/2020';
    const ToexpiryDate = '10/30/2020';
    return currentDate >= FromDate && currentDate <= ToexpiryDate;
  }

  hasCapturedGrossIncome(creditHealthInfo: any): boolean {
    const grossIncome = creditHealthInfo?.grossIncome;
    return !(grossIncome == undefined || grossIncome == null || grossIncome == 0);
  }
}
